import React from 'react';
import classNames from 'classnames';
import TopUpIcon from 'assets/img/icons/topup.svg';
import Button from 'components/CustomButtons/Button';
import { translate } from 'components/Translation';
import Add from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/topupStyle';
import { BodyS, DisplayS } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);

interface NoNumbersProps {
	handleAddNumber: () => void;
}

const NoNumbers = ({ handleAddNumber }: NoNumbersProps) => {
	const classes = useStyles();
	return (
		<div className={classNames(classes.wrapper, classes.addNumbersWrapper)}>
			<img alt="topup" src={TopUpIcon} className={classes.icon} />
			<DisplayS>{translate('payments.topup.addNumbers')}</DisplayS>
			<BodyS>{translate('payments.topup.asMany')}</BodyS>
			<Button
				id="add-numbers-button"
				color="primary-light"
				className={classes.addNumbersButton}
				onClick={handleAddNumber}
			>
				<>
					<Add />
					{translate('payments.topup.addNumbersButton')}
				</>
			</Button>
		</div>
	);
};

export default NoNumbers;
